import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import AuthToken from '../../utils/AuthToken';
import { API_URL } from '../../constants';
import { Rate } from 'rsuite';
import { Link } from 'react-router-dom';
import { useTokens } from '../../context/TokenContext';

const ProductPerformance = ({ userToken }) => {
  const { getItem } = useTokens();
  const adminAuthToken = getItem('admin', 'AuthToken');
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchProductPerformance = async () => {
    setLoading(true);
    const token = userToken || adminAuthToken;
  
    if (!token) {
      toast.error("Admin token missing. Please login again.");
      setLoading(false);
      return;
    }
  
    try {
      const { data } = await axios.get(`${API_URL}/dashboard/product-performance`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      setProducts(data || []);
    } catch (error) {
      console.error("Fetch error:", error);
      toast.error('Failed to fetch product performance');
    } finally {
      setLoading(false);
    }
  };  

  useEffect(() => {
    fetchProductPerformance();
  }, []);

  return (
    <div className="container my-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="fs-6 mb-0">Product Performance</h4>
        <Link to='/admin/product' className="btn btn-sm btn-outline-primary">
          See All
        </Link>
      </div>

      <div className="table-responsive">
        <table className="table table-striped table-hover align-middle">
          <thead className="table-dark">
            <tr>
              <th>Product Name</th>
              <th>Sold</th>
              <th>Stock</th>
              <th>Rating</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="4" className="text-center py-4">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </td>
              </tr>
            ) : products.length > 0 ? (
              products.map((product) => (
                <tr key={product.id}>
                  <td>{product.title || '—'}</td>
                  <td>{product.sold ?? 0}</td>
                  <td>{product.stock ?? 0}</td>
                  <td><Rate defaultValue={product.rating} color="orange" size='xs' disabled='true' /></td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="text-center py-3">No product data available.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ProductPerformance;
